import {Link} from "react-router-dom";

const BackButton = ({to, text}) => {
    return <Link to={to} className="btn btn-sm btn-secondary ml-1 mr-1">
        <i className="fas fa-arrow-left" />&nbsp;&nbsp;&nbsp;{text}
    </Link>
};

export default BackButton;
